<template>
    <div class="TagListSection form__actions">
        <div class="title">{{ title }}</div>
        <div class="flex wrap mb-5">
            <a-badge v-for="tag in tagList" class="mr-2 mb-2">{{ tag.name }}</a-badge>
            <input type="hidden" v-for="tag in tagList" :name="fieldName" :value="tag.value">
            <ABtn class="form-btn btn-add" fill="transparent" type="button"
                  @click="addTag">
                <template #before>
                    <svg class="icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <rect y="9" width="20" height="2"/>
                        <rect x="9" y="20" width="20" height="2" transform="rotate(-90 9 20)"/>
                    </svg>
                </template>
                <template #content>{{ editMode ? messages.saveTag : messages.addTag }}</template>
            </ABtn>
        </div>
        <ASelect
            class="a-select-tags"
            v-if="editMode===true"
            :label="messages.addTag"
            :name="''"
            :placeholder="additionalTagName.value!=undefined?additionalTagName.name:messages.placeholderTag"
            staticLabel
            :options="canOption"
            @change="setSelect"
            display="name"
            value=value
            :multiple="false"
            :error="false"
        >
          <template #item="item">
            <div class="flex v-center">
              <a-checkbox :label="item.name" v-model="item.selected"/>
            </div>
          </template>
        </ASelect>
    </div>
</template>

<script>
// https://i.imgur.com/scSOeJG.png reference
import {computed, ref} from "vue";
import {ABadge, ABtn, AInput,     ACheckbox, ASelect} from "../ui";

export default {
    name: "TagListSection",
    props: {
        title: String,
        tags: Array,
        messages: Object,
        options: Array,
        fieldName: {
            type: String,
            required: true
        }
    },
    components: {
        ABadge,
      ACheckbox,
        ABtn,
        AInput,
        ASelect
    },
    setup(props) {
        const editMode = ref(false)
        const additionalTagName = ref({});
        const canOption = computed(()=> {
          let opt = [];
          let issetIndex = [];
          for (let ind in tagList.value) {
            if(tagList.value[ind].value)
            issetIndex.push(tagList.value[ind].value);
          }
          for (let ind in props.options) {
            if(issetIndex.indexOf(props.options[ind].value)<0&&props.options[ind].name) {
              opt.push(props.options[ind]);
            }
          }
          return opt;
        })
        const tagList = computed({
            get() {
                return props.tags
            },
            set(val) {
                props.tags = [...val]
            }
        })

        const setSelect = (tar) => {
          for(let indx in props.options) {
            if(props.options[indx].value==tar) {
              additionalTagName.value = props.options[indx];
            }
          }
        };
        const addTag = () => {
            if (!editMode.value) {
                // add
                editMode.value = true;
            } else {
                //save


              if(additionalTagName.value.name!=undefined) {
                tagList.value.push(additionalTagName.value)
              }

                additionalTagName.value = ''
                editMode.value = false;
            }
        }

        return {
            tagList,
            addTag,
            canOption,
            editMode,
            setSelect,
            additionalTagName
        }
    }
}
</script>

<style scoped lang="scss">
.title {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
}

::v-deep .a-btn {
    margin: 0;
}
</style>